.container {
  display: flex;
  flex-direction: column;
  flex: 1;
  max-width: 100%;
  overflow-y: auto;
  height: 100%;
  max-height: calc(100% - 4rem);
}
